import { render, staticRenderFns } from "./flexibleEndoscopes.vue?vue&type=template&id=72e66646&scoped=true&"
import script from "./flexibleEndoscopes.vue?vue&type=script&lang=js&"
export * from "./flexibleEndoscopes.vue?vue&type=script&lang=js&"
import style1 from "./flexibleEndoscopes.vue?vue&type=style&index=1&id=72e66646&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e66646",
  null
  
)

export default component.exports